var prevent_multiple_submission_service = {
    // 複製したボタンを不活化して、オリジナルのボタンは非表示にする。オリジナルを不活化すると送信が失敗する。
    init_disablable_button: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .prevent_double_click') : $('.prevent_double_click');
        element.on('click', function(){
            var cloneButton = $(this).clone();
            cloneButton.insertAfter($(this));
            cloneButton.prop("disabled", true);
            $(this).hide();
        });
    }
};

export {prevent_multiple_submission_service};